export class ApiError extends Error {
  public statusCode: number | undefined
  public data: unknown

  constructor(message: string, statusCode?: number, data?: unknown) {
    super(message)
    this.name = 'ApiError'
    this.statusCode = statusCode
    this.data = data
  }
}

export class NotFoundError extends ApiError {
  constructor(message = 'Resource not found') {
    super(message, 404)
    this.name = 'NotFoundError'
  }
}

export class ValidationError extends ApiError {
  constructor(message = 'Validation failed') {
    super(message, 400)
    this.name = 'ValidationError'
  }
}

export class UnauthorizedError extends ApiError {
  constructor(message = 'Unauthorized') {
    super(message, 401)
    this.name = 'UnauthorizedError'
  }
}

export class MaintainanceError extends ApiError {
  constructor(message = 'Server under maintaincance') {
    super(message, 503)
    this.name = 'MaintainanceError'
  }
}

export async function withErrorHandling<T>(
  fn: () => Promise<T>,
  contextMessage = 'An error occurred',
): Promise<T> {
  try {
    return await fn()
  } catch (error: unknown) {
    if (error instanceof ApiError) {
      throw error
    }
    throw new ApiError(contextMessage, undefined, error)
  }
}
